'use es6';

import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import layoutSectionUpdateDomMiddleware from 'InpageEditorUI/redux/middleware/layoutSectionUpdateDomMiddleware';
import postMessageMiddleware from 'InpageEditorUI/redux/middleware/postMessageMiddleware';
import pauseReduxDebuggingMiddleware from 'ContentEditorUI/redux/middleware/pauseReduxDebuggingMiddleware';
const getMiddleware = opts => [thunk, pauseReduxDebuggingMiddleware, postMessageMiddleware(opts.eventBus), layoutSectionUpdateDomMiddleware];
export function configureStore(rootReducer, eventBus) {
  const createStoreWithMiddleware = compose(applyMiddleware(...getMiddleware({
    eventBus
  })))(createStore);
  return createStoreWithMiddleware(rootReducer);
}